<template>
    <div class="space-y-6 col-span-1">
        <div class="-mr-4 bg-white col-span-1 overflow-hidden shadow rounded-lg divide-y divide-gray-200 w-full">
            <div class="px-4 py-3 sm:px-4">
                <div class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap">
                    <div class="ml-4 mt-2">
                        <h3 class="text-base leading-6 font-medium text-gray-900">
                          {{ this.$i18n.t('message.users.usuarios') }}
                        </h3>
                    </div>
                </div>
            </div>
            <div class="px-4 py-6" align="center">
              <span class="rounded-md shadow-sm">
                <button type="button" @click="openModalCreate = true" class="items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150">
                  {{$t('message.users.agregarusuario')}}
                </button>
              </span>
            </div>
            <div class="px-4 py-6">
              <data-table-interactive :headers="headers" :data="users" />
            </div>
        </div>
        <modal :open="openModalCreate" @closeModal="openModalCreate = false" :title="$t('message.users.agregarusuario')" :maxWidth="60" >
          <form @submit.prevent="createUser">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.nombres')}} *</label>
                <input type="text" v-model="user.name" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.apellidos')}} *</label>
                <input type="text" v-model="user.lastname" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.nombreusuario')}} *</label>
                <input type="text" v-model="user.login" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.email')}} *</label>
                <input type="email" v-model="user.email" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.email2')}}</label>
                <input type="email" v-model="user.email_2" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.identificador')}}</label>
                <input type="text" v-model="user.code" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.pin')}}</label>
                <input type="text" v-model="user.pin" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.ingresarnuevacontrasena')}} *</label>
                <input type="password" v-model="user.password" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                <small>* {{$t('message.users.formatocontrasena')}}</small>
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.verificarcontrasena')}} *</label>
                <input type="password" v-model="user.password_verification" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.tipousuario')}} *</label>
                <select v-model="user.type" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                  <option v-for="tu in typeuser" :key="tu.id" :value="tu.id" > {{$t(`message.users.${tu.name}`)}} </option>
                </select>
              </div>
              <div class="col-span-full" align="center">
                <span class="rounded-md shadow-sm">
                  <button type="submit" class="items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-green-200 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150">
                    {{$t('message.users.guardarcambios')}}
                  </button>
                </span>
              </div>
            </div>
          </form>
        </modal>
        <modal :open="openModalEdit" @closeModal="openModalEdit = false" :title="$t('message.users.editarusuariotitulo')" :maxWidth="60" >
          <form @submit.prevent="saveChangeUser">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.nombres')}} *</label>
                <input type="text" v-model="user.name" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.apellidos')}} *</label>
                <input type="text" v-model="user.lastname" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.nombreusuario')}} *</label>
                <input type="text" v-model="user.login" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.email')}} *</label>
                <input type="email" v-model="user.email" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.email2')}}</label>
                <input type="email" v-model="user.email_2" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.identificador')}}</label>
                <input type="text" v-model="user.code" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.pin')}}</label>
                <input type="text" v-model="user.pin" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-1">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.tipousuario')}} *</label>
                <select v-model="user.type" required class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                  <option v-for="tu in typeuser" :key="tu.id" :value="tu.id" > {{$t(`message.users.${tu.name}`)}} </option>
                </select>
              </div>
              <div class="col-span-full" align="center">
                <span class="rounded-md shadow-sm">
                  <button type="submit" class="items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-green-200 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150">
                    {{$t('message.users.guardarcambios')}}
                  </button>
                </span>
              </div>
            </div>
          </form>
        </modal>
        <modal :open="openModalPassword" @closeModal="openModalPassword = false" :title="$t('message.users.editarcontrasenatitulo')" :maxWidth="30" >
          <form @submit.prevent="saveChangePassword">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-3">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.ingresarnuevacontrasena')}}</label>
                <input type="password" v-model="password.password" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                <small>* {{$t('message.users.formatocontrasena')}}</small>
              </div>
              <div class="col-span-3">
                <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.users.verificarcontrasena')}}</label>
                <input type="password" v-model="password.password_verification" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              </div>
              <div class="col-span-full" align="center">
                <span class="rounded-md shadow-sm">
                  <button type="submit" class="items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-green-200 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150">
                    {{$t('message.users.guardarcambios')}}
                  </button>
                </span>
              </div>
            </div>
          </form>
        </modal>
    </div>
</template>

<script>
import DataTableInteractive from '@/components/DataTable/DataTableInteractive'
import Modal from '@/components/Modal'

export default {
  components: { DataTableInteractive, Modal },
  name: 'users',
  data() {
    return {
      labels: [],
      nav: 'detenciones',
      headers: [
        {
          title: 'Id',
          data: 'id',
          type: Number
        },
        {
          title: this.$i18n.t('message.users.nombres'),
          data: 'name'
        },
        {
          title: this.$i18n.t('message.users.apellidos'),
          data: 'lastname'
        },
        {
          title: this.$i18n.t('message.users.email'),
          data: 'email'
        },
        {
          title: this.$i18n.t('message.users.email2'),
          data: 'email_2'
        },
        {
          title: this.$i18n.t('message.users.nombreusuario'),
          data: 'login'
        },
        {
          title: this.$i18n.t('message.users.identificador'),
          data: 'code'
        },
        {
          title: this.$i18n.t('message.users.tipousuario'),
          data: 'type_name'
        },
        {
          title: this.$i18n.t('message.users.estado'),
          data: 'state',
          transform: (row) => row.state === 'Habilitado' ? this.$i18n.t('message.users.habilitado') : this.$i18n.t('message.users.desabilitado'),
          render: (row) => `<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 bg-${row.state === 'Habilitado' ? 'green' : 'red'}-100 text-${row.state === 'Habilitado' ? 'green' : 'red'}-800">
              ${row.state === 'Habilitado' ? this.$i18n.t('message.users.habilitado') : this.$i18n.t('message.users.desabilitado')}
            </span>`
        },
        {
          title: this.$i18n.t('message.users.acciones'),
          actions: [
            {
              text: this.$i18n.t('message.users.editarusuario'),
              className: 'bg-blue-400',
              action: (row) => this.editUser(row)
            },
            {
              text: this.$i18n.t('message.users.modificarcontrasena'),
              className: 'bg-yellow-400',
              action: (row) => this.changePassword(row.id)
            },
            {
              text: this.$i18n.t('message.users.modificarestado'),
              className: 'bg-green-400',
              action: (row) => this.changeState(row)
            }
          ]
        }
      ],
      users: [],
      typeuser: [],
      openModalCreate: false,
      openModalEdit: false,
      openModalPassword: false,
      user: {},
      password: {}
    };
  },
  created(){
      this.fetchUsers();
      this.fetchTypeUser();
  },
  methods: {
    async createUser(){
      if(!this.$store.state.isLoading){
        if (this.user.password && this.user.password === this.user.password_verification){
          const payload = {
            user: {
              code: this.user.code,
              name: this.user.name,
              lastname: this.user.lastname,
              email: this.user.email,
              email_2: this.user.email_2 !== '' ? this.user.email_2 : null,
              password: this.user.password,
              type: this.user.type,
              login: this.user.login,
              pin: this.user.pin !== '' ? this.user.pin : null
            }
          }
          const response = await this.$http.post(`/users`, payload).catch(err => err);
          if (response.data?.result){
            this.fetchUsers()
            this.openModalCreate = false;
          }else{
            alert(response.response.data.message);
          }
        }else{
          alert(this.$i18n.t('message.users.errorcontrasena'));
        }
      }
    },
    async editUser(user){
      if(!this.$store.state.isLoading){
        const { data } = await this.$http.get(`/users/${user.id}`);
        this.user = data;
        this.openModalEdit = true;
      }
    },
    changePassword(id){
      this.user.id = id;
      this.openModalPassword = true;
    },
    changeState(user){
      this.user.id = user.id;
      const payload = {
        user: {
          state: user.state === 'Habilitado' ? 'Inhabilitado' : 'Habilitado'
        }
      }
      this.changeUser(payload);
    },
    async fetchUsers() {
      const { data } = await this.$http.get(`/users`);
      this.users = data;
    },
    async fetchTypeUser() {
      const { data } = await this.$http.get(`/typeuser`);
      this.typeuser = data;
    },
    async changeUser(payload, nameModal=false){
      if(!this.$store.state.isLoading){
        const response = await this.$http.put(`/users/${this.user.id}`, payload).catch(err => err);
        if (response.data?.result === 1){
          this.fetchUsers()
          if (nameModal) this[nameModal] = false;
        }else{
          alert(response.response.data.message);
        }
      }
    },
    saveChangeUser(){
      const user = {
        user: {
          name: this.user.name,
          lastname: this.user.lastname,
          email: this.user.email,
          email_2: this.user.email_2 !== '' ? this.user.email_2 : null,
          code: this.user.code,
          password: this.user.password,
          type: this.user.type,
          pin: this.user.pin !== '' ? this.user.pin : null,
          login: this.user.login
        }
      }
      this.changeUser(user, 'openModalEdit');
    },
    saveChangePassword(){
      if (this.password.password && this.password.password === this.password.password_verification){
        const user = {
          user: {
            password: this.password.password
          }
        }
        this.changeUser(user, 'openModalPassword');
      }else{
        alert(this.$i18n.t('message.users.errorcontrasena'));
      }
    }
  },
  watch:{
    openModalPassword(){
      this.password = {};
    },
    openModalCreate(){
      this.user = {};
    }
  }
};
</script>
